var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.297,
    height: 42.297,
    viewBox: "0 0 42.297 42.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(25.296 26.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M1011.49,429.085a.929.929,0,0,1-1.023-.786v-9.425a1.059,1.059,0,0,1,2.046,0V428.3A.928.928,0,0,1,1011.49,429.085Z",
    transform: "translate(-1006.387 -418.089)",
    fill: "#e82a73",
    stroke: "#e82a73",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M1016.134,424.229a1.018,1.018,0,0,1-.724-.3l-3.368-3.369-3.368,3.368a1.024,1.024,0,0,1-1.448-1.448l4.093-4.092a1.024,1.024,0,0,1,1.447,0l4.093,4.092a1.024,1.024,0,0,1-.725,1.748Z",
    transform: "translate(-1006.939 -418.089)",
    fill: "#e82a73",
    stroke: "#e82a73",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M998.4,429.4H979.471a.861.861,0,0,1-.86-.861V402.728a.868.868,0,0,1,.251-.609l10.325-10.325a.868.868,0,0,1,.609-.251h18.93a.861.861,0,0,1,.861.861v18.929a.861.861,0,1,1-1.721,0V393.264H990.153l-9.821,9.821v24.6H998.4a.861.861,0,1,1,0,1.721Z",
    transform: "translate(-978.611 -391.543)",
    fill: "#7b7b8e",
    stroke: "#7b7b8e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M989.8,403.589H979.471a.861.861,0,0,1,0-1.721h9.464V392.4a.861.861,0,0,1,1.721,0v10.324A.86.86,0,0,1,989.8,403.589Z",
    transform: "translate(-978.611 -391.543)",
    fill: "#7b7b8e",
    stroke: "#7b7b8e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1011.069,433.962A9.961,9.961,0,1,1,1021.03,424,9.974,9.974,0,0,1,1011.069,433.962Zm0-18.111a8.15,8.15,0,1,0,8.149,8.15A8.161,8.161,0,0,0,1011.069,415.851Z",
    transform: "translate(-979.233 -392.165)",
    fill: "#f5f6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M995.4,415.977a.861.861,0,0,1-.861-.861V404.792a.861.861,0,0,1,.861-.861h3.441a.861.861,0,0,1,0,1.721H996.26v9.465A.862.862,0,0,1,995.4,415.977Z",
    transform: "translate(-979.051 -391.885)",
    fill: "#7b7b8e",
    stroke: "#7b7b8e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M992.671,417.942c-1.931,0-3.442-1.134-3.442-2.581s1.511-2.582,3.442-2.582,3.442,1.134,3.442,2.582S994.6,417.942,992.671,417.942Z",
    transform: "translate(-978.905 -392.13)",
    fill: "#7b7b8e",
    stroke: "#7b7b8e",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.6d53fa6686496f20150d28bc3213a2a2.svg";
export { ForwardRef as ReactComponent };